import { Case, CaseStatuses, OrderStatuses } from "@types-runway/case";
import { RootEntity } from "@types-runway/state";
import { deriveOrderPaymentState, OrderPaymentState } from "@utils/billing/orderPaymentState";

enum ListRank {
  DECLINED = 0,
  IN_PROGRESS = 1,
  PAID_OR_COMPLETED = 2,
  CANCELLED = 3,
}

const rankOf = (case_: Case): ListRank => {
  const isCancelled =
    case_.case_status === CaseStatuses.CANCELLED ||
    case_.CurexaOrder?.status === OrderStatuses.CANCELLED;
  if (isCancelled) {
    return ListRank.CANCELLED;
  }

  const paymentState = deriveOrderPaymentState(case_);
  if (paymentState === OrderPaymentState.PAYMENT_FAILED) {
    return ListRank.DECLINED;
  }

  const isUnderReview = case_.case_status !== CaseStatuses.COMPLETED;
  if (isUnderReview || paymentState === OrderPaymentState.UNKNOWN) {
    return ListRank.IN_PROGRESS;
  }

  return ListRank.PAID_OR_COMPLETED;
};

const timeOf = (case_: Case) => new Date(case_.updatedAt).getTime() || 0;

export const selectOrderedCases = (cases: RootEntity<Case>[]): RootEntity<Case>[] =>
  [...cases].sort(
    (first, second) =>
      rankOf(first.data) - rankOf(second.data) || timeOf(second.data) - timeOf(first.data)
  );
